const Header = ({ logo }) => {
  return (
    <header className="flex h-[10vh] border-b-4 border-gray-700 z-10 fixed justify-between items-center w-full bg-black py-5 px-5 sm:px-8">
      <img src={logo} alt="logo" className="h-10 sm:h-12" />
      <a
        href="https://bit.ly/3PvH1Lj"
        className="px-3 sm:px-6 py-2 sm:py-2.5 border-2 sm:text-xl border-rose-600 text-white hover:bg-zinc-800 active:bg-zinc-900 outline-none"
      >
        Enroll Now
      </a>
    </header>
  );
};

export default Header;
